"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventProducer = void 0;
var config_1 = require("../config");
var event_id_1 = require("../meta/event-id");
var event_creator_1 = require("./event-creator");
function EventProducer(platform, env, logErrors, eventIdGenerator, options) {
    if (logErrors === void 0) { logErrors = false; }
    if (eventIdGenerator === void 0) { eventIdGenerator = event_id_1.ULIDEventIDGenerator(); }
    var config = config_1.getConfig(env);
    // eventCreator may be reassigned if configureOptions is called.
    var eventCreator = event_creator_1.EventCreator(eventIdGenerator, (options === null || options === void 0 ? void 0 : options.embeddedOptions)
        ? {
            embeddedOptions: options.embeddedOptions,
        }
        : undefined);
    function send(event, type) {
        return __awaiter(this, void 0, void 0, function () {
            var url, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = config.baseUrl + "/v1/" + type;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, platform.fetch(url, {
                                method: 'POST',
                                mode: 'cors',
                                keepalive: true,
                                credentials: 'omit',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(event),
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        if (logErrors) {
                            console.warn("ignored failure to send " + type + ":", error_1);
                        }
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function appStartEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'app-start-event')];
                }
            });
        });
    }
    function articleReadEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'article-read-event')];
                }
            });
        });
    }
    function bookingEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'booking-event')];
                }
            });
        });
    }
    function bookingCancellationEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'booking-cancellation-event')];
                }
            });
        });
    }
    function clickEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'click-event')];
                }
            });
        });
    }
    function lobbyPresenceEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'lobby-presence-event')];
                }
            });
        });
    }
    function lobbySessionEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'lobby-session-event')];
                }
            });
        });
    }
    function meetingLaunchEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'meeting-launch-event')];
                }
            });
        });
    }
    function notificationRequestEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'notification-request-event')];
                }
            });
        });
    }
    function pageViewEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'page-view-event')];
                }
            });
        });
    }
    function partnerCouponSubmittedEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'partner-coupon-submitted-event')];
                }
            });
        });
    }
    function pushNotificationEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'push-notification-event')];
                }
            });
        });
    }
    function recommendationClickEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'recommendation-click-event')];
                }
            });
        });
    }
    function recommendationRequestEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'recommendation-request-event')];
                }
            });
        });
    }
    function searchEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'search-event')];
                }
            });
        });
    }
    function socialChatMessageEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'social-chat-message-event')];
                }
            });
        });
    }
    function socialConnectRequestEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'social-connect-request-event')];
                }
            });
        });
    }
    function socialReactionEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'social-reaction-event')];
                }
            });
        });
    }
    function watchEvent(props) {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, eventCreator.createEvent(platform, props)];
                    case 1:
                        event = _a.sent();
                        return [2 /*return*/, send(event, 'watch-event')];
                }
            });
        });
    }
    function configureOptions(options) {
        eventCreator = event_creator_1.EventCreator(eventIdGenerator, (options === null || options === void 0 ? void 0 : options.embeddedOptions)
            ? {
                embeddedOptions: options.embeddedOptions,
            }
            : undefined);
    }
    return {
        appStartEvent: appStartEvent,
        articleReadEvent: articleReadEvent,
        bookingEvent: bookingEvent,
        bookingCancellationEvent: bookingCancellationEvent,
        clickEvent: clickEvent,
        lobbyPresenceEvent: lobbyPresenceEvent,
        lobbySessionEvent: lobbySessionEvent,
        meetingLaunchEvent: meetingLaunchEvent,
        notificationRequestEvent: notificationRequestEvent,
        pageViewEvent: pageViewEvent,
        partnerCouponSubmittedEvent: partnerCouponSubmittedEvent,
        pushNotificationEvent: pushNotificationEvent,
        recommendationClickEvent: recommendationClickEvent,
        recommendationRequestEvent: recommendationRequestEvent,
        searchEvent: searchEvent,
        socialChatMessageEvent: socialChatMessageEvent,
        socialConnectRequestEvent: socialConnectRequestEvent,
        socialReactionEvent: socialReactionEvent,
        watchEvent: watchEvent,
        configureOptions: configureOptions,
    };
}
exports.EventProducer = EventProducer;
//# sourceMappingURL=producer.js.map